import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from '@mui/material';
import React from 'react';
import { IUnsavedNavigationDialogResult } from 'types/dialogs';

interface IUnsavedNavigationDialogProps {
	onClose: (res: IUnsavedNavigationDialogResult) => void;
}

const UnsavedNavigationDialog: React.FC<IUnsavedNavigationDialogProps> = ({
	onClose
}) => (
	<Dialog
		open
		maxWidth="sm"
		fullWidth
		PaperProps={{ elevation: 0 }}
		onClose={() => onClose({ proceed: false })}
	>
		<DialogTitle>
			{intl.tr('ssoConfig.testPage.unsavedDialog.title')}
		</DialogTitle>
		<DialogContent>
			<DialogContentText>
				{intl.tr('ssoConfig.testPage.unsavedDialog.message')}
			</DialogContentText>
		</DialogContent>
		<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
			<Button
				variant="outlined"
				color="error"
				onClick={() => onClose({ proceed: true })}
				data-testid="unsaved-leave-button"
			>
				{intl.tr('ssoConfig.testPage.unsavedDialog.leaveButton')}
			</Button>
			<Button
				variant="contained"
				onClick={() => onClose({ proceed: false })}
				data-testid="unsaved-stay-button"
			>
				{intl.tr('ssoConfig.testPage.unsavedDialog.stayButton')}
			</Button>
		</DialogActions>
	</Dialog>
);

export default UnsavedNavigationDialog;
